/** @jsxImportSource react */
import { Community } from '@common/types';
import Section from '@react/data-hub/components/DatahubSection';
import useSearch from '@react/search/hooks/useSearch';
import dynamic from 'next/dynamic';

const EntityTile = dynamic(
  () => import(/* webpackChunkName: "chunkEntityTile" */ '@react/card')
);

const ExploreCommunities = ({
  careType,
  cityName,
}: {
  careType: string;
  cityName: string;
}) => {
  const { communities } = useSearch({
    'page-size': 6,
  });

  if (!communities?.length) {
    return null;
  }

  return (
    <Section
      heading={`Explore top ${careType} communities in the ${cityName} area`}
    >
      <div
        className='mt-6 grid auto-rows-auto gap-6 md:grid-cols-2 lg:grid-cols-3'
        data-tp-id='gen-div-f44ab4b6-63d5-49cf-afaf-b6a42dcf4f8f'
      >
        {communities.map((community: Community) => (
          <EntityTile key={community.id} entity={community} intent='vertical' />
        ))}
      </div>
    </Section>
  );
};

export default ExploreCommunities;
